import React, { useMemo } from 'react';
import { Bar, Line, Doughnut } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import { ChartSpec } from 'clients/ChatClient';
import { sharedGraphOptions, filteredLegendOptions } from 'components/RevenueWidgets/helpers';
import styles from './ChatChart.module.css';

function buildBarOptions(data: number[]): ChartOptions<'bar'> {
    const maxVal = Math.max(...data, 0);
    const suggestedMax = Math.round(maxVal * 1.1);
    const base = sharedGraphOptions(suggestedMax);
    return {
        ...base,
        maintainAspectRatio: false,
        plugins: {
            ...base.plugins,
            legend: { ...filteredLegendOptions, display: true },
            datalabels: { display: false },
        },
    };
}

const doughnutOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { ...filteredLegendOptions, display: true },
        datalabels: { display: false },
    },
};

interface ChatChartProps {
    spec: ChartSpec;
}

const ChatChart: React.FC<ChatChartProps> = ({ spec }) => {
    const chartData = { labels: spec.labels, datasets: spec.datasets };

    const barOptions = useMemo(() => {
        const allValues = spec.datasets.flatMap((ds) => ds.data);
        return buildBarOptions(allValues);
    }, [spec]);

    return (
        <div className={styles.container}>
            {spec.title && <div className={styles.title}>{spec.title}</div>}
            <div className={styles.chart}>
                {spec.type === 'bar' && <Bar data={chartData} options={barOptions} />}
                {spec.type === 'line' && <Line data={chartData} options={barOptions as ChartOptions<'line'>} />}
                {spec.type === 'doughnut' && <Doughnut data={chartData} options={doughnutOptions} />}
            </div>
        </div>
    );
};

export default ChatChart;
